import { render } from "./assessment-mobile-placeholder.vue?vue&type=template&id=4dd52401&scoped=true&ts=true"
import script from "./assessment-mobile-placeholder.vue?vue&type=script&lang=ts"
export * from "./assessment-mobile-placeholder.vue?vue&type=script&lang=ts"

import "./assessment-mobile-placeholder.vue?vue&type=style&index=0&id=4dd52401&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd52401"]])

export default __exports__